import { Task } from "../Task/Task";
export class Subscription {
    constructor() {
        this.eventSubscribers_ = new Set();
        this.status_ = "inactive";
        this.statusSubscribers_ = new Set();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    emit(value) {
        return Task.all(Array.from(this.eventSubscribers_).map(sub => sub(value) || Task.empty()));
    }
    subscribe(fn) {
        this.eventSubscribers_.add(fn);
        this.checkStatus_();
        return () => {
            this.eventSubscribers_.delete(fn);
            this.checkStatus_();
        };
    }
    clear() {
        this.eventSubscribers_.clear();
        this.checkStatus_();
    }
    onStatusChange(fn) {
        this.statusSubscribers_.add(fn);
        return () => this.statusSubscribers_.delete(fn);
    }
    checkStatus_() {
        const newstatus = this.eventSubscribers_.size > 0 ? "active" : "inactive";
        if (newstatus === this.status_) {
            return;
        }
        this.status_ = newstatus;
        Array.from(this.statusSubscribers_).map(sub => sub(newstatus));
    }
}
